<template>
  <!-- 电脑端显示 -->
  <div class="Footer" v-if="windowWidth >= 800">
    <div class="container">
      <div class="main">
        <div class="infoCon">
          <p class="title">{{ copyData.footer.footerAbout }}</p>
          <a href="./about.html?id=1">
            <p class="text">{{ copyData.footer.footerSynopsis }}</p>
          </a>
          <a href="./about.html?id=2">
            <p class="text">{{ copyData.footer.footerDevelop }}</p>
          </a>
          <a href="./about.html?id=3">
            <p class="text">{{ copyData.footer.footerHonor }}</p>
          </a>
          <a href="./about.html?id=4">
            <p class="text">{{ copyData.footer.footerTeam }}</p>
          </a>
        </div>
        <div class="infoCon">
          <p class="title">{{ copyData.footer.footerProducts }}</p>
          <a href="./productSpring.html">
            <p class="text">{{ copyData.footer.footerSpring }}</p>
          </a>
          <a href="./productHardware.html">
            <p class="text">{{ copyData.footer.footerHardware }}</p>
          </a>
        </div>
        <div class="infoCon">
          <p class="title">{{ copyData.footer.footerTechnology }}</p>
          <a href="./technology.html?id=1">
            <p class="text">{{ copyData.footer.footerEchnicalAdvantages }}</p>
          </a>
          <a href="./technology.html?id=2">
            <p class="text">{{ copyData.footer.footerProductionEquipment }}</p>
          </a>
          <a href="./technology.html?id=3">
            <p class="text">{{ copyData.footer.footerInspectionEquipment }}</p>
          </a>
          <a href="./technology.html?id=4">
            <p class="text">{{ copyData.footer.footerWorkshopEnvironment }}</p>
          </a>
        </div>
        <div class="infoCon special">
          <p class="title">{{ copyData.footer.footerContact }}</p>
          <p class="text">{{ copyData.footer.footerTel }}</p>
          <p class="text">{{ copyData.footer.footerFax }}</p>
          <p class="text">{{ copyData.footer.footerEmail }}</p>
          <p class="text">{{ copyData.footer.footerAddress }}</p>
        </div>
      </div>
    </div>
    <div class="footerInfo">
      <p>{{ copyData.footer.footerInfo }}</p>
    </div>
  </div>
  <!-- 手机端显示 -->
  <div class="Footer" v-else>
    <img src="../../assets//images/homeView/LOGO.png" alt="" class="logo">
    <div class="container">
      <div class="titleCon" @click="menuTag == 1 ? menuTag = 0 : menuTag = 1">
        <p>{{ copyData.footer.footerAbout }}</p>
        <img src="../../assets/images/homeView/arro.png" alt="" class="arro" :class="menuTag == 1 ? 'arroAct' : ''">
      </div>
      <div class="menuCon" v-if="menuTag == 1">
        <a href="./about.html?id=1">
          <div class="menuList">{{ copyData.footer.footerSynopsis }}</div>
        </a>
        <a href="./about.html?id=2">
          <div class="menuList">{{ copyData.footer.footerDevelop }}</div>
        </a>
        <a href="./about.html?id=3">
          <div class="menuList">{{ copyData.footer.footerHonor }}</div>
        </a>
        <a href="./about.html?id=4">
          <div class="menuList">{{ copyData.footer.footerTeam }}</div>
        </a>
      </div>
      <div class="titleCon" @click="menuTag == 2 ? menuTag = 0 : menuTag = 2">
        <p>{{ copyData.footer.footerProducts }}</p>
        <img src="../../assets/images/homeView/arro.png" alt="" class="arro" :class="menuTag == 2 ? 'arroAct' : ''">
      </div>
      <div class="menuCon" v-if="menuTag == 2">
        <a href="./productSpring.html">
          <div class="menuList">{{ copyData.footer.footerSpring }}</div>
        </a>
        <a href="./productHardware.html">
          <div class="menuList">{{ copyData.footer.footerHardware }}</div>
        </a>
      </div>
      <div class="titleCon" @click="menuTag == 3 ? menuTag = 0 : menuTag = 3">
        <p>{{ copyData.footer.footerTechnology }}</p>
        <img src="../../assets/images/homeView/arro.png" alt="" class="arro" :class="menuTag == 3 ? 'arroAct' : ''">
      </div>
      <div class="menuCon" v-if="menuTag == 3">
        <a href="./technology.html?id=1">
          <div class="menuList">{{ copyData.footer.footerEchnicalAdvantages }}</div>
        </a>
        <a href="./technology.html?id=2">
          <div class="menuList">{{ copyData.footer.footerProductionEquipment }}</div>
        </a>
        <a href="./technology.html?id=3">
          <div class="menuList">{{ copyData.footer.footerInspectionEquipment }}</div>
        </a>
        <a href="./technology.html?id=4">
          <div class="menuList">{{ copyData.footer.footerWorkshopEnvironment }}</div>
        </a>
      </div>
      <div class="titleCon contact">
        <p>{{ copyData.footer.footerContact }}</p>
      </div>
      <div class="contactInfo">
        <p>{{ copyData.footer.footerTel }}</p>
        <p>{{ copyData.footer.footerFax }}</p>
        <p>{{ copyData.footer.footerEmail }}</p>
        <p>{{ copyData.footer.footerAddress }}</p>
      </div>
    </div>
    <div class="footerInfo">
      <p>{{ copyData.footer.footerInfo }}</p>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, reactive } from "vue";
import { chinese } from "../../language/zh";
import { english } from "../../language/en"

export default defineComponent({

  setup(){
    const copyData = ref({})
    // 获取当前语言
    const getLanguage = () => {
      copyData.value = english
    }
    // 获取当前屏幕的宽度
    const windowWidth = ref(document.body.clientWidth);

    // 移动端点击菜单
    const menuTag = ref(0)

    getLanguage()

    return{
      chinese,
      english,
      copyData,
      getLanguage,
      windowWidth,
      menuTag,
    }
  }
})
</script>


<style scoped lang="less">
// 电脑端样式
.Footer {
  width: 100%;
  height: 345px;

  .container {
    width: 100%;
    height: 300px;
    background: #282828;
    display: flex;
    justify-content: center;
    align-items: center;

    .main {
      width: auto;
      height: 160px;
      display: flex;
      justify-content: center;
      align-items: center;

      .infoCon {
        width: auto;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        border-left: 1px solid hsla(0, 0%, 100%, 0.2);
        padding: 0 90px;

        .title {
          font-size: 14px;
          color: #FEFEFE;
          font-family: 'SourceHanSansCN';
          // margin-bottom: 22px;
          line-height: 14px;
        }

        .text {
          font-size: 14px;
          color: #999999;
          font-family: 'SourceHanSansCN';
          cursor: pointer;
          line-height: 14px;
          height: 14px;
          margin: 7px 0;
        }

        .text:hover {
          color: hsla(0, 0%, 100%, 0.8);
        }
      }

      .special {
        border-right: 1px solid hsla(0, 0%, 100%, 0.2);
      }
    }
  }

  .footerInfo {
    width: 100%;
    height: 45px;
    background: #202020;
    color: #999999;
    font-size: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

html[lang="en"] {
  .Footer {
    .container{
      .main {
        .infoCon{
          padding: 0 40px;

          &.special{
            max-width: 28rem;
          }

          .text{
            text-align: left;
            line-height: 22px;
          }
        }
      }
    }
  }
}

// 手机端样式
@media screen and (max-width: 900px) {
  .Footer {
    width: 100%;
    height: auto;
    box-sizing: border-box;
    padding: 5vw;
    background: #eaeaea;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    .logo {
      height: 8vw;
      width: auto;
      margin-bottom: 4vw;
    }

    .container {
      width: 90vw;
      height: auto;
      background: #00000000;
      display: flex;
      flex-direction: column;

      .titleCon {
        width: 100%;
        height: 8vw;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #BFBFBF;
        font-weight: 600;
        font-size: 3.8vw;
        margin-bottom: 2vw;

        .arro {
          height: 2vw;
          width: auto;
          transform: rotate(180deg);
        }

        .arroAct {
          transform: rotate(0deg);
        }
      }

      .contact {
        border-bottom: none;
      }

      .menuCon {
        width: 90vw;
        height: auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;

        .menuList {
          width: 90vw;
          height: 6vw;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          font-size: 3.2vw;
          border-bottom: 1px solid #BFBFBF;
        }
      }

      .contactInfo {
        width: 90vw;
        background: #f4f4f4;
        font-size: 3.2vw;
        text-align: left;
        padding: 0 4vw;
        box-sizing: border-box;
        border-radius: 1.5vw;
      }
    }

    .footerInfo {
      background: none;
      margin-top: 5vw;
      color: #2C3E50;
      font-size: 3.2vw;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Footer.vue?e863ec26